<ion-app>
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <app-backdrop-loading></app-backdrop-loading>
  <app-alert></app-alert>
  <app-toast></app-toast>
  <app-splash-screen></app-splash-screen>
</ion-app>
